module.exports = __webpack_public_path__ + "media/images/favicon-3b75b85ca82d95af3a786f807d5fdada.png";